"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShieldOfKatalinaAbilityHandler = exports.ShieldOfKatalinaActorAbilityFactory = exports.ShieldOfKatalinaAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const Haste_1 = require("../../core/effects/core/Haste");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
class ShieldOfKatalinaAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ShieldOfKatalina;
        this.__typeName = "ShieldOfKatalina";
    }
}
exports.ShieldOfKatalinaAbilityArgs = ShieldOfKatalinaAbilityArgs;
let ShieldOfKatalinaActorAbilityFactory = class ShieldOfKatalinaActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ShieldOfKatalina", "Self", 4);
    }
};
ShieldOfKatalinaActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ShieldOfKatalina")
], ShieldOfKatalinaActorAbilityFactory);
exports.ShieldOfKatalinaActorAbilityFactory = ShieldOfKatalinaActorAbilityFactory;
let ShieldOfKatalinaAbilityHandler = class ShieldOfKatalinaAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.CriticalStrikeChance, 5),
            duration: Duration_1.Duration.Turns(8),
        });
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new __1.LinkedEffectsEffectArgs([
                new Haste_1.HasteEffectArgs(1),
                new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.BurnDamageIncrease, 50)
            ], false),
            duration: Duration_1.Duration.Turns(4),
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(ability.invokerId, "chest"), "MagicBubble"));
            }
        });
    }
};
ShieldOfKatalinaAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ShieldOfKatalina)
], ShieldOfKatalinaAbilityHandler);
exports.ShieldOfKatalinaAbilityHandler = ShieldOfKatalinaAbilityHandler;
